{
  "endTime": "Время окончания",
  "startTime": "Время начала",
  "time": "Время"
}
